<template>
  <div class="service-setting">
    <div class="tuolele-main-box flex-wrap">
      <div class="service-item flex-wrap">
        <div class="service-img img-wrap">
          <img src="@/assets/img/service-setting-item1.png" alt="">
        </div>
        <div class="service-content">
          <div class="fn-clear">
            <div class="fn-left service-name">
              班主任常见问题<i class="free-icon">免费</i>
            </div>
            <div class="fn-right">
              <el-button
                v-if="dataInfo.FAQ == 0"
                type="primary"
                @click="changeStatus('FAQ', 1)"
              >确认添加</el-button>
              <el-button
                v-else
                type="info"
                @click="changeStatus('FAQ', 0)"
              >取消添加</el-button>
            </div>
          </div>
          <div class="service-notice">
            <p>使用角色：班主任</p>
            <p>产品介绍：在线提升班主任工作能力，班主任学成成长平台。</p>
          </div>
        </div>
      </div>
      <div class="service-item flex-wrap">
        <div class="service-img img-wrap">
          <img src="@/assets/img/service-setting-item1.png" alt="">
        </div>
        <div class="service-content">
          <div class="fn-clear">
            <div class="fn-left service-name">
              云端资料<i class="free-icon">免费</i>
            </div>
            <div class="fn-right">
              <el-button
                v-if="dataInfo.CLOUD_DATA == 0"
                type="primary"
                @click="changeStatus('CLOUD_DATA', 1)"
              >确认添加</el-button>
              <el-button
                v-else
                type="info"
                @click="changeStatus('CLOUD_DATA', 0)"
              >取消添加</el-button>
            </div>
          </div>
          <div class="service-notice">
            <p>使用角色：班主任</p>
            <p>产品介绍：在线学科、习惯等海量资料库。</p>
          </div>
        </div>
      </div>
      <div class="service-item flex-wrap">
        <div class="service-img img-wrap">
          <img src="@/assets/img/service-setting-item3.png" alt="">
        </div>
        <div class="service-content">
          <div class="fn-clear">
            <div class="fn-left service-name">
              工作汇报<i class="free-icon">免费</i>
            </div>
            <div class="fn-right">
              <el-button
                v-if="dataInfo.WORK_REPORT == 0"
                type="primary"
                @click="changeStatus('WORK_REPORT', 1)"
              >确认添加</el-button>
              <el-button
                v-else
                type="info"
                @click="changeStatus('WORK_REPORT', 0)"
              >取消添加</el-button>
            </div>
          </div>
          <div class="service-notice">
            <p>使用角色：校长、班主任、销售</p>
            <p>
              产品介绍：团队管理应用，校长向员工发起工作汇报，员工进行填写汇报。
            </p>
          </div>
        </div>
      </div>
      <div class="service-item flex-wrap">
        <div class="service-img img-wrap">
          <img src="@/assets/img/service-setting-item4.png" alt="">
        </div>
        <div class="service-content">
          <div class="fn-clear">
            <div class="fn-left service-name">
              leads、学员转校<i class="free-icon">免费</i>
            </div>
            <div class="fn-right">
              <el-button
                v-if="dataInfo.CHANGE_SCHOOL == 0"
                type="primary"
                @click="changeStatus('CHANGE_SCHOOL', 1)"
              >确认添加</el-button>
              <el-button
                v-else
                type="info"
                @click="changeStatus('CHANGE_SCHOOL', 0)"
              >取消添加</el-button>
            </div>
          </div>
          <div class="service-notice">
            <p>使用角色：校长</p>
            <p>产品介绍：多校区leads、学员管理。</p>
          </div>
        </div>
      </div>
      <div class="service-item flex-wrap">
        <div class="service-img img-wrap">
          <img src="@/assets/img/service-setting-item5.png" alt="">
        </div>
        <div class="service-content">
          <div class="fn-clear">
            <div class="fn-left service-name">
              回访管理<i class="free-icon">免费</i>
            </div>
            <div class="fn-right">
              <el-button
                v-if="dataInfo.VISIT_RECORD == 0"
                type="primary"
                @click="changeStatus('VISIT_RECORD', 1)"
              >确认添加</el-button>
              <el-button
                v-else
                type="info"
                @click="changeStatus('VISIT_RECORD', 0)"
              >取消添加</el-button>
            </div>
          </div>
          <div class="service-notice">
            <p>使用角色：校长</p>
            <p>产品介绍：校长可对学员定期回访，添加回访记录。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceSetting',
  components: {},
  data() {
    return {
      dataInfo: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getVasList()
  },
  methods: {
    async getVasList() {
      const ret = await this.$http.getVasList()
      if (ret.code == 200) {
        this.dataInfo = ret.data.company_switch
      }
    },
    async changeStatus(key, value) {
      const ret = await this.$http.setVasSubmit({
        key,
        value
      })
      if (ret.code == 200) {
        this.getVasList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.service-setting {
  .tuolele-main-box {
    padding: 40px 0 40px 20px;
    flex-wrap: wrap;
    .service-item {
      padding: 30px 20px 0;
      box-sizing: border-box;
      width: 515px;
      height: 170px;
      border-radius: 10px;
      border: solid 1px #d9d9d9;
      margin-right: 20px;
      margin-bottom: 20px;
      .service-img {
        width: 90px;
        height: 90px;
      }
      .service-content {
        flex: 1;
        color: $color_black;
        padding-left: 20px;
        .service-name {
          line-height: 40px;
          .free-icon {
            font-style: normal;
            color: $color_blue;
            border: 1px solid $color_blue;
            padding: 3px 6px;
            margin-left: 10px;
            border-radius: 2px;
          }
        }
        .service-notice {
          font-size: 14px;
          p {
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.el-button {
  width: 120px;
  height: 40px;
}
</style>
